import { Building2, Plus, SearchX } from "lucide-react";
import { Button } from "@/components/ui/button";

type EmptyStateProps = {
  variant: "no-sessions" | "no-matches";
  onAddCompany: () => void;
  isBusy?: boolean;
};

export function EmptyState({ variant, onAddCompany, isBusy }: EmptyStateProps) {
  const Icon = variant === "no-matches" ? SearchX : Building2;
  const ctaLabel =
    variant === "no-matches" ? "Adaugă companie" : "Adaugă prima companie";

  return (
    <div
      data-testid="portfolio-empty-state"
      data-variant={variant}
      className="rounded-xl border-2 border-dashed border-ds-border-200 bg-white py-16 text-center"
    >
      <Icon className="h-10 w-10 mx-auto text-ds-text-400 mb-4" />
      <h3 className="font-heading text-lg font-semibold text-navy-900 mb-1">
        Nicio companie găsită
      </h3>
      <p className="text-sm text-ds-text-400 mb-4">
        Adaugă prima companie pentru a începe
      </p>
      <Button
        onClick={onAddCompany}
        disabled={isBusy}
        data-testid="portfolio-empty-state-add"
        className="gap-2"
      >
        <Plus className="h-4 w-4" />
        {ctaLabel}
      </Button>
    </div>
  );
}
